import { render, staticRenderFns } from "./AgentDetail.vue?vue&type=template&id=34c60b0f&scoped=true"
import script from "./AgentDetail.vue?vue&type=script&lang=js"
export * from "./AgentDetail.vue?vue&type=script&lang=js"
import style0 from "./AgentDetail.vue?vue&type=style&index=0&id=34c60b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c60b0f",
  null
  
)

export default component.exports